import './customYupValidators' // self-registers the custom yup validators
import * as yupImport from 'yup'

const dateRange = () =>
  yupImport.object().shape({
    from: yupImport.date().required(),
    to: yupImport.date().required(),
  })

export const yup = { ...yupImport, dateRange }
